import { ConfiguratorConfig, ConfigurationsRegistry } from '@icc/configurator/types';
import { PleatedBlindActiveConfiguration } from './pleated-blind-active-configuration';
import { PleatedBlindConfiguration } from './pleated-blind-configuration';

export const PLEATED_BLIND_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'pleated_blind',
    activeConfigurationClass: PleatedBlindActiveConfiguration,
    configurationClass: PleatedBlindConfiguration
};

export function registerPleatedBlindConfigurations(): void {
    ConfigurationsRegistry.register(PLEATED_BLIND_CONFIGURATOR_CONFIG);
}
